import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

/** Butonul rotund din colțul fiecărui card, care deschide istoricul metricii. */
export function HistoryButton({ onClick, title }: { onClick: () => void; title: string }) {
  return (
    <Tooltip title={title}>
      <IconButton
        onClick={onClick}
        aria-label={title}
        sx={(theme) => ({
          width: 34,
          height: 34,
          flex: 'none',
          borderRadius: `${theme.radii.pill}px`,
          backgroundColor: theme.palette.weather.bg,
          color: theme.palette.weather.soft,
          transition: 'background-color .2s ease, color .2s ease',
          '&:hover': {
            backgroundColor: theme.palette.weather.accentSoft,
            color: theme.palette.weather.accent,
          },
        })}
      >
        {/* Lucide „line-chart”, inline ca să moștenească currentColor. */}
        <svg
          width="17"
          height="17"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden
        >
          <path d="M3 3v18h18" />
          <path d="m7 14 4-4 3 3 5-6" />
        </svg>
      </IconButton>
    </Tooltip>
  );
}
